module.exports = __webpack_public_path__ + "img/modelshow03-1.52e62119.png";